import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        inAppBar: {
            listStyleType: 'none',
            margin: '0px 0px 20px 0px',
            padding: 0
        },
        icon: {
            verticalAlign: 'text-bottom',
            marginRight: '5px'
        },
        itemClass: {
            display: 'inline-block',
            marginRight: 12,
            color: theme.palette.text.disabled,
            fontSize: '14px',
            fontWeight: 500,
            textAlign: 'center',
            height: '20px',
            padding: '12px 0px 8px 0px',
            backgroundColor: 'transparent',
            '&:hover': {
                cursor: 'pointer'
            },
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        },
        selected: {
            display: 'inline-block',
            fontSize: '14px',
            fontWeight: 500,
            marginRight: 12,
            height: '20px',
            borderBottom: 'solid 2px ' + theme.palette.primary.main,
            padding: '12px 0px 8px 0px',
            textAlign: 'center',
            color: theme.palette.primary.main,
            '&:hover': {
                cursor: 'pointer'
            },
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        }
    }, globalStyles);
};

class TabbedSubmenu extends React.Component {

    state = {
        tab: 0
    };

    onChangeTab = (index) => this.setState({ tab: index });

    render() {

        const { tabs, classes, compact } = this.props;
        const { tab } = this.state;
        const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];

        return (
            <div data-test="submenu" style={compact ? {} : { padding: '0px 6px 6px 6px' }}>
                <ul
                    className={classes.inAppBar}
                    data-test={"menu-selected-" + tabs[tab]}
                    style={compact ?
                        { padding: '0px 6px 0px 6px' }
                        : {}}>
                    {tabs.map((item, index) => {
                        const selected = index === tab;
                        const itemClass = selected ? classes.selected : classes.itemClass;
                        return <li
                            key={index}
                            tabIndex={0}
                            className={itemClass}
                            data-selected={selected}
                            data-test={"menu-option-" + item}
                            onKeyDown={(ev) => {
                                if (ev.key === "Enter") {
                                    ev.preventDefault();
                                    ev.stopPropagation();
                                    this.onChangeTab(index);
                                }
                            }}
                            onClick={() => this.onChangeTab(index)}>
                            <span>
                                {item}
                            </span>
                        </li>;
                    })}
                </ul>
                {children[tab]}
            </div>
        );
    }
}

TabbedSubmenu.defaultProps = {
    compact: false
};

TabbedSubmenu.propTypes = {
    tabs: PropTypes.array.isRequired,
    classes: PropTypes.object,
    children: PropTypes.any
};

export default withStyles(styles)(TabbedSubmenu);